'use client';

import { useState, useEffect, useLayoutEffect } from 'react';

const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<{
    height: number;
    width: number;
  }>({
    width: 0,
    height: 0,
  });

  // Sync dimensions before first paint to avoid visible flicker
  useIsomorphicLayoutEffect(() => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  }, []);

  useEffect(() => {
    let rafId: number | null = null;
    let lastWidth = window.innerWidth;
    let lastHeight = window.innerHeight;

    function handleResize() {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(() => {
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        if (newWidth !== lastWidth || newHeight !== lastHeight) {
          lastWidth = newWidth;
          lastHeight = newHeight;
          setWindowSize({ width: newWidth, height: newHeight });
        }
        rafId = null;
      });
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      if (rafId !== null) cancelAnimationFrame(rafId);
    };
  }, []);

  return windowSize;
};
